import { resolveLocale } from '@mai-team-amusement/core';
import { createI18n } from '@mai-team-amusement/i18n';
import { browserLanguages } from '@mai-team-amusement/ui';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.js';
import { clockNamespace } from './i18n/index.js';

const root = document.getElementById('root');
if (root === null) {
  throw new Error('#root is missing');
}

const i18n = await createI18n({
  locale: resolveLocale(null, browserLanguages()),
  appNamespaces: [clockNamespace],
});

createRoot(root).render(
  <StrictMode>
    <App i18n={i18n} />
  </StrictMode>,
);
